import React from 'react'
import SectionTitle from '../Title'
import { Link } from 'react-router-dom'
import './style.scss'

// images
import blog1 from '../../images/blog/1.jpg'
import blog2 from '../../images/blog/2.jpg'
import blog3 from '../../images/blog/3.jpg'
import blog4 from '../../images/blog/4.jpg'
import blog5 from '../../images/blog/5.jpg'
import blog6 from '../../images/blog/6.jpg'
import blog7 from '../../images/blog/7.jpg'
import blog8 from '../../images/blog/8.jpg'

import blog10 from '../../images/blog/10.jpg'
import blog11 from '../../images/blog/11.jpg'
import blog12 from '../../images/blog/12.jpg'
import blog13 from '../../images/blog/13.jpg'
import blog14 from '../../images/blog/14.jpg'
import blog15 from '../../images/blog/15.jpg'
import blog16 from '../../images/blog/16.jpg'
import blog17 from '../../images/blog/17.jpg'
import blog18 from '../../images/blog/18.jpg'
import blog19 from '../../images/blog/19.jpg'
import blog20 from '../../images/blog/20.jpg'
import blog21 from '../../images/blog/21.jpg'
import blog22 from '../../images/blog/22.jpg'
import blog23 from '../../images/blog/23.jpg'
import blog24 from '../../images/blog/24.jpg'
import blog25 from '../../images/blog/25.jpg'

import blog26 from '../../images/blog/26.jpg'
import blog27 from '../../images/blog/27.jpg'
import blog28 from '../../images/blog/28.jpg'
import blog29 from '../../images/blog/29.jpg'
import blog30 from '../../images/blog/30.jpg'
import blog31 from '../../images/blog/31.jpg'
import blog32 from '../../images/blog/32.jpg'
import blog33 from '../../images/blog/33.jpg'
import blog34 from '../../images/blog/34.jpg'
import blog35 from '../../images/blog/35.jpg'
import blog36 from '../../images/blog/36.jpg'
import blog37 from '../../images/blog/37.jpg'
import blog38 from '../../images/blog/38.jpg'
import blog39 from '../../images/blog/39.jpg'
import blog40 from '../../images/blog/40.jpg'
import blog41 from '../../images/blog/41.jpg'

import blog42 from '../../images/blog/42.jpg'
import blog43 from '../../images/blog/43.jpg'
import blog44 from '../../images/blog/44.jpg'
import blog45 from '../../images/blog/45.jpg'
import blog46 from '../../images/blog/46.jpg'
import blog47 from '../../images/blog/47.jpg'

const blogs = [
  {
    images: blog1,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog2,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog3,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog4,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog5,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog6,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog7,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog8,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },

  {
    images: blog10,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog11,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog12,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog13,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog14,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog15,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog16,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog17,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog18,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog19,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog20,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog21,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog22,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog23,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog24,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog25,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog26,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog27,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog28,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog29,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog30,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog31,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog32,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog33,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog34,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog35,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog36,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog37,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog38,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog39,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog40,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog41,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog42,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog43,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog44,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog45,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog46,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
  {
    images: blog47,
    title: 'Lighting',
    meta: {
      // avatar: avatar,
      name: 'By Aliza',
      time: 'Oct 12,2018',
    },
  },
]

const BlogArea = ({ className, title, subTitle }) => {
  return (
    <div className={className}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionTitle title={title} subTitle={subTitle} />
          </div>
          {blogs.map((blog, i) => (
            <div key={i} className="col-lg-3 col-sm-6 col-12">
              <div className="blogWrap">
                <div className="blogImage">
                  <img src={blog.images} alt="" />
                </div>
                <div className="blogContent">
                  {/* <h3><Link to="/blog-fullwidth">Justice May For You If  You Are Innocent</Link></h3> */}
                  <ul className="blogMeta">
                    {/* <li><img src={blog.meta.avatar} alt="" /></li> */}
                    {/* <h3>{blog.title}</h3> */}
                    {/* <li>{blog.meta.time}</li> */}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default BlogArea
